import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewTransactionListingComponent } from '../new-transaction-listing/new-transaction-listing.component';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { GoogleReviewModalComponent } from '../google-review-modal/google-review-modal.component';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-new-sub-admins-rental-auth',
  templateUrl: './new-sub-admins.component.html',
  styleUrls: ['./new-sub-admins.component.scss'],
})
export class NewSubAdminsRentalAuth implements OnInit {
  transactions: any;
  total_txn: number = 0;
  tab_type = 3;
  userDropdown: { name: string; }[];
  slotTransactions: any;
  
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService
  ) {}

  ngOnInit(): void { 
    this.vip_sub_transactions(); 
  }
    
  vip_sub_transactions() {
    let  show = '5';
    this.auth.vip_transactions(show).subscribe((response: any) => {
      this.transactions = response.body.transactions;
      this.total_txn = response.body.available;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }
 
   
}
